export default "__VITE_ASSET__DLdSCrc3__"